// Pre-computed stable positions for rose petals
const PETALS = Array.from({ length: 18 }, (_, i) => ({
  left: `${(i * 31 + 5) % 100}%`,
  delay: `${(i * 0.8) % 10}s`,
  duration: `${10 + ((i * 7) % 8)}s`,
  scale: 0.6 + ((i * 13) % 10) / 10,
}));

export default function Petals({ className = "" }) {
  return (
    <div
      aria-hidden="true"
      className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}
    >
      {PETALS.map((p, i) => (
        <span
          key={i}
          className="petal"
          style={{
            left: p.left,
            animationDelay: p.delay,
            animationDuration: p.duration,
            transform: `scale(${p.scale})`,
          }}
        />
      ))}
    </div>
  );
}
